module.exports = __webpack_public_path__ + "static/media/pickdestination.49599530.svg";